const TournamentDetailCard = ({
  title,
  children,
  className,
}: {
  title: string;
  children?: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className={`card p-2 ${className}`}>
      <div className="card-body overflow-hidden">
        <h6 className="text-muted text-uppercase text-xs">{title}</h6>
        {children}
      </div>
    </div>
  );
};

export default TournamentDetailCard;
